import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';

import { getAge } from '../app-data/date';
import { options } from './data';
import { Management } from './management';
import { CustomerLog } from './customerLog';

export const UserPopup = ({ id, admin, onUserClose }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [wake, setWake] = useState(new Date());
  const [wakeLog, setWakeLog] = useState(new Date());

  useEffect(() => {
    let active = true;
    async function load() {
      const res = await axios.get(`/users/${id}`, options());
      if (!active) {
        return;
      }
      setUser({
        ...res.data.user,
        age: getAge(res.data.user.birth_date),
      });
      setLoading(false);
    }
    load();

    return () => {
      active = false;
    };
  }, [id]);

  if (loading) return <p>Loading...</p>;

  return (
    <Tabs isFitted variant="enclosed">
      <TabList>
        <Tab>
          <Box>General</Box>
        </Tab>
        <Tab>
          <Box>Customer log</Box>
        </Tab>
      </TabList>

      <TabPanels>
        <TabPanel px={0}>
          <Management {...{ admin, id, user, wake, setWake, onUserClose }} />
        </TabPanel>
        <TabPanel>
          <CustomerLog {...{ admin, id, wakeLog, setWakeLog, onUserClose }} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
